module.exports = __webpack_public_path__ + "img/team-02.aa762547.jpg";